import { Theme } from '@monorepo/relayably/theme'
import { ArrowLeft, CheckCircle, Lifebuoy, Mailbox, ShieldCheck } from 'phosphor-react-native'
import { useState } from 'react'
import { Pressable, Text, TextInput, View } from 'react-native'
import { createPaneStyles } from './shared'

export const RecoveryPane = ({
  mode,
  onBack,
  onStartRecovery,
  theme,
}: {
  mode: 'FORGOT_PASSWORD' | 'RECOVERY'
  onBack: () => void
  onStartRecovery: () => void
  theme: Theme
}) => {
  const styles = createPaneStyles(theme)
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  if (submitted) {
    return (
      <View style={styles.successView}>
        <View style={styles.successIconWrap}>
          <CheckCircle color={theme.colors.positive} size={32} weight='fill' />
        </View>
        <View style={{ gap: 8 }}>
          <Text style={{ color: theme.colors.text, fontSize: 20, fontWeight: '700', textAlign: 'center' }}>Check your inbox</Text>
          <Text style={{ color: theme.colors.inactive, fontSize: 14, lineHeight: 22, textAlign: 'center' }}>
            We&apos;ve sent a link to {email}. It will expire in 15 minutes.
          </Text>
        </View>
        <Text onPress={onBack} style={styles.actionLink}>
          Return to Sign In
        </Text>
      </View>
    )
  }

  return (
    <View style={styles.pane}>
      {mode === 'FORGOT_PASSWORD' ? (
        <View style={styles.form}>
          <View style={styles.fieldGroup}>
            <Text style={styles.label}>Registered Email</Text>
            <View style={styles.inputIconWrap}>
              <Mailbox color={theme.colors.inactive} size={18} style={styles.inputIcon} />
              <TextInput
                autoCapitalize='none'
                keyboardType='email-address'
                onChangeText={setEmail}
                style={[styles.input, styles.iconInput]}
                value={email}
              />
            </View>
          </View>

          <Pressable onPress={() => setSubmitted(true)} style={styles.submitButton}>
            <Text style={styles.submitButtonText}>Send Recovery Link</Text>
          </Pressable>

          <View style={styles.tertiaryCard}>
            <Lifebuoy color={theme.colors.inactive} size={20} />
            <View style={styles.tertiaryColumn}>
            <Text style={styles.tertiaryTitle}>Can&apos;t access your email?</Text>
            <Text style={styles.tertiaryBody}>
                If you can&apos;t get into your email, you can start account recovery instead.
              </Text>
              <Text onPress={onStartRecovery} style={styles.actionLink}>
                Start recovery
              </Text>
            </View>
          </View>
        </View>
      ) : (
        <View style={styles.form}>
          <View style={styles.tertiaryCard}>
            <ShieldCheck color={theme.colors.inactive} size={24} />
            <View style={styles.tertiaryColumn}>
              <Text style={styles.tertiaryTitle}>ID check required</Text>
              <Text style={styles.tertiaryBody}>
                To recover your account without email, we need a passport or driver&apos;s licence.
              </Text>
            </View>
          </View>

          <Pressable
            style={[
              styles.submitButton,
              {
                backgroundColor: 'transparent',
                borderColor: theme.colors.text,
                borderWidth: 1,
              },
            ]}
          >
            <Text style={[styles.submitButtonText, { color: theme.colors.text }]}>Start ID check</Text>
          </Pressable>
        </View>
      )}

      <Pressable onPress={onBack} style={styles.navButton}>
        <ArrowLeft color={theme.colors.text} size={16} />
        <Text style={styles.navButtonText}>Back to sign in</Text>
      </Pressable>
    </View>
  )
}
